import { render, staticRenderFns } from "./CreateGroupCompany.vue?vue&type=template&id=29f2334f&"
import script from "./CreateGroupCompany.vue?vue&type=script&lang=js&"
export * from "./CreateGroupCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports